import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectors as licenseSelectors } from 'store/licenseManager'
import { operations as reportsOperations } from 'store/reportsManager'
import { navigationEvent } from 'layers/navigation/store/operations'
import NavigationHelper from 'layers/navigation/navigationHelper'
import { createSiteOptions } from 'components/ReportsNavHeader/helpers'
import ReportsPageHeader from './component'

export const ReportsPageHeaderContainer = ({
  administratorsCount,
  gradeNameForUnitNavigation,
  hasClassesWithCompletedLessonLastPeriod,
  numClassesWithCompletedLessonLastPeriod,
  period,
  entry,
  gradeOrSiteName,
  hasDwbAccess,
  isSchoolSummary,
  k8ReportUnitSection,
  lastUpdatedAt,
  navigationHandler,
  navigationEvent,
  selectedSite,
  sites,
  teachersCount,
  tooltipText,
  totalClassesCount,
  updateSelectedSite,
}) => {
  const navigateTo = url => {
    const type = NavigationHelper.types.PUSH
    navigationEvent(url, type)
  }

  const rawSites = Array.isArray(sites) ? sites : []
  const siteOptions = createSiteOptions(rawSites)
  const selectedSiteOption = siteOptions.find(
    ({ key }) => key === selectedSite || String(key) === String(selectedSite),
  )

  return (
    <ReportsPageHeader
      administratorsCount={administratorsCount}
      entry={entry}
      gradeNameForUnitNavigation={gradeNameForUnitNavigation}
      gradeOrSiteName={gradeOrSiteName}
      hasClassesWithCompletedLessonLastPeriod={
        hasClassesWithCompletedLessonLastPeriod
      }
      hasDwbAccess={hasDwbAccess}
      isSchoolSummary={isSchoolSummary}
      k8ReportUnitSection={k8ReportUnitSection}
      lastUpdatedAt={lastUpdatedAt}
      navigateTo={navigateTo}
      navigationEvent={navigationEvent}
      navigationHandler={navigationHandler}
      numClassesWithCompletedLessonLastPeriod={
        numClassesWithCompletedLessonLastPeriod
      }
      period={period}
      selectedSite={selectedSite}
      selectedSiteOption={selectedSiteOption}
      siteOptions={siteOptions}
      teachersCount={teachersCount}
      tooltipText={tooltipText}
      totalClassesCount={totalClassesCount}
      updateSelectedSite={updateSelectedSite}
    />
  )
}

ReportsPageHeaderContainer.propTypes = {
  administratorsCount: PropTypes.number,
  entry: PropTypes.object,
  gradeNameForUnitNavigation: PropTypes.string,
  gradeOrSiteName: PropTypes.string,
  hasClassesWithCompletedLessonLastPeriod: PropTypes.bool,
  hasDwbAccess: PropTypes.bool,
  isSchoolSummary: PropTypes.bool,
  k8ReportUnitSection: PropTypes.string,
  lastUpdatedAt: PropTypes.string,
  navigationEvent: PropTypes.func,
  navigationHandler: PropTypes.func,
  numClassesWithCompletedLessonLastPeriod: PropTypes.number,
  period: PropTypes.number,
  selectedSite: PropTypes.number,
  sites: PropTypes.arrayOf(PropTypes.object),
  teachersCount: PropTypes.number,
  tooltipText: PropTypes.string,
  totalClassesCount: PropTypes.number,
  updateSelectedSite: PropTypes.func,
}

const mapStateToProps = state => {
  const adminK8SitesWithDwb = licenseSelectors.selectActiveAdminK8SitesWithDwb(
    state,
  )
  const hasDwbAccess = adminK8SitesWithDwb.length > 1
  return {
    hasDwbAccess,
    selectedSite: state.reportsManager?.selectedSite,
    sites: licenseSelectors.selectActiveAdminK8Sites(state),
  }
}

const mapDispatchToProps = {
  navigationEvent,
  updateSelectedSite: reportsOperations.updateSelectedSite,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportsPageHeaderContainer)
